import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkDirective from 'remark-directive';
import { visit } from 'unist-util-visit';
import Notification from './Notification';

const Markdown = ({ children }: { children: string }) => {
  return <ReactMarkdown remarkPlugins={PLUGINS} components={COMPONENTS as any}>{children}</ReactMarkdown>;
};


const PLUGINS = [remarkGfm, remarkDirective, myComponentsPlugin];


const COMPONENT_DEFS: Record<string, {
  props: string[],
  Component: React.ComponentType
}> = {
  notification: {
    props: ["color"],
    Component: Notification
  },
}
const COMPONENTS = Object.entries(COMPONENT_DEFS).reduce((_, [k, v]) => {
  const {Component} = v;
  _[k] = (props: any) => <Component {...props} />;
  return _;
}, {} as Record<string, React.ComponentType>);

type Node = Parameters<typeof visit>[0] & {
  name: string,
  children?: Node[],
  value?: string,
  data?: {
    hName?: string,
    hProperties?: Record<string, string>,
  }
};


function myComponentsPlugin() {
  return (tree: Node) => {
    visit(tree, (node: Node) => {
      const componentDef = COMPONENT_DEFS[node.name];
      if (node.type === 'containerDirective' && componentDef) {
        const data = node.data || (node.data = {});
        const params = node.children?.[0]?.children;

        const props = params ? componentDef.props.reduce((_, prop, index) => {
          const value = params[index]?.value;
          if (value) _[prop] = value;
          return _;
        }, {} as Record<string, string>) : {}

        if (params) {
          node.children?.splice(0, 1);
        }

        node.children = node.children ? node.children.reduce((_, child) => {
          if (child && child.type === 'paragraph'){
            _.push(...(child.children ?? []));
          } else {
            _.push(child);
          }
          return _;
        }, [] as Node[]) : undefined;

        data.hName = node.name;
        data.hProperties = props;
      }
    });
  };
}

export default Markdown;
